module.exports = function getResource(label, vars = []) {
    let resources = {
        minutes: 'min'
    };

    return resources[label];
};
